<template>
  <v-dialog v-model="dialog" max-width="290" persistent>
    <v-card>
      <v-card-title class="justify-center">앱 업데이트 안내</v-card-title>

      <v-card-text class="text-left ftw7">
        안전한 서비스 이용을 위해 업데이트가 필요합니다.<br />
        최신 버전으로 업데이트 후 이용해 주세요.
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="primary" class="ftw7" min-height="30" block @click="moveToStore()">
          업데이트
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  FORCE_UPDATE_MIN_APP_VERSION,
  LYNNLIFE_STORE_URL,
  compareVersion,
  getAppPlatform,
  isFlutterApp,
} from "@/utils/appVersion";

export default {
  name: "ForceUpdateDialog",

  data() {
    return {
      dialog: false,
      resolved: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    // failClosed: 앱 정보 조회 실패 시 구버전(getAppInfo 미지원 등)으로 보고 업데이트 팝업 노출
    checkAppVersion(failClosed) {
      if (this.resolved) return;

      window.flutter_inappwebview
        .callHandler("getAppInfo", this.$store.getters.getIdToken)
        .then((result) => {
          if (this.resolved) return;
          const version = JSON.parse(result).app_version;
          this.resolved = true;
          this.dialog = compareVersion(version, FORCE_UPDATE_MIN_APP_VERSION) < 0;
        })
        .catch((error) => {
          if (this.resolved || !failClosed) return;
          this.resolved = true;
          this.dialog = true;

          this.$store.dispatch("LOGGING", {
            error: error.message || error,
            tags: `flutter_inappwebview|force_update_checkAppVersion_failed(${this
              .user?.email || "unknown"})`,
            etc: {},
          });
        });
    },
    onPlatformReady() {
      this.checkAppVersion(true);
    },
    moveToStore() {
      const storeUrl = LYNNLIFE_STORE_URL[getAppPlatform()];
      if (storeUrl) {
        window.location.href = storeUrl;
      }
    },
  },
  mounted() {
    if (!isFlutterApp()) return;

    // 브릿지가 이미 준비된 경우 바로 체크하고, 준비 전이면 platformReady 이벤트에서 체크
    window.addEventListener("flutterInAppWebViewPlatformReady", this.onPlatformReady, {
      once: true,
    });
    if (window.flutter_inappwebview?.callHandler) {
      this.checkAppVersion(false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("flutterInAppWebViewPlatformReady", this.onPlatformReady);
  },
};
</script>
